import axios from 'axios'

export const LastVisitedApiInstance = axios.create({
  baseURL: '',
  timeout: 5000,
})
